// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3C5p0","title":"Images45_title__3N66F","images":"Images45_images__39KDE"};